import { SFPalette } from '@/lib/color';

export default function SFFlagUsCircleIcon({ color = SFPalette.lightGrey2 }) {
  return (
    <svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_113_11584"
        // style="mask-type:luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="32"
        height="32"
      >
        <path
          d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16345 0 0 7.16344 0 16C0 24.8366 7.16345 32 16 32Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_113_11584)">
        <circle cx="16" cy="16" r="16" fill="white" />
        <path d="M14.521 0.045166H-8.08887V17.4199H14.521V0.045166Z" fill="#032B7A" />
        <path
          d="M1.30836 0.337158L1.46981 0.831H1.98977L1.56715 1.13728L1.7286 1.63349L1.30836 1.32722L0.885745 1.63349L1.04719 1.13728L0.626953 0.831H1.14691L1.30836 0.337158Z"
          fill="white"
        />
        <path
          d="M5.04566 0.337158L5.20474 0.831H5.72707L5.30446 1.13728L5.4659 1.63349L5.04566 1.32722L4.62305 1.63349L4.7845 1.13728L4.36426 0.831H4.88422L5.04566 0.337158Z"
          fill="white"
        />
        <path
          d="M8.87037 0.337158L9.03182 0.831H9.55178L9.12916 1.13728L9.29061 1.63349L8.87037 1.32722L8.44776 1.63349L8.60921 1.13728L8.18896 0.831H8.70892L8.87037 0.337158Z"
          fill="white"
        />
        <path
          d="M3.14137 2.1416L3.30282 2.63544H3.82277L3.40253 2.94172L3.56161 3.43794L3.14137 3.13166L2.71875 3.43794L2.8802 2.94172L2.45996 2.63544H2.97992L3.14137 2.1416Z"
          fill="white"
        />
        <path
          d="M6.87818 2.1416L7.03963 2.63544H7.55959L7.13935 2.94172L7.29842 3.43794L6.87818 3.13166L6.45557 3.43794L6.61702 2.94172L6.19678 2.63544H6.71674L6.87818 2.1416Z"
          fill="white"
        />
        <path
          d="M10.7034 2.1416L10.8648 2.63544H11.3848L10.9645 2.94172L11.1236 3.43794L10.7034 3.13166L10.2831 3.43794L10.4422 2.94172L10.022 2.63544H10.5419L10.7034 2.1416Z"
          fill="white"
        />
        <path
          d="M12.4319 0.337158L12.5933 0.831H13.1133L12.6931 1.13728L12.8545 1.63349L12.4319 1.32722L12.0117 1.63349L12.1731 1.13728L11.7505 0.831H12.2704L12.4319 0.337158Z"
          fill="white"
        />
        <path
          d="M1.30836 3.93652L1.46981 4.43037H1.98977L1.56715 4.73664L1.7286 5.23286L1.30836 4.92658L0.885745 5.23286L1.04719 4.73664L0.626953 4.43037H1.14691L1.30836 3.93652Z"
          fill="white"
        />
        <path
          d="M5.04566 3.93652L5.20474 4.43037H5.72707L5.30446 4.73664L5.4659 5.23286L5.04566 4.92658L4.62305 5.23286L4.7845 4.73664L4.36426 4.43037H4.88422L5.04566 3.93652Z"
          fill="white"
        />
        <path
          d="M8.87037 3.93652L9.03182 4.43037H9.55178L9.12916 4.73664L9.29061 5.23286L8.87037 4.92658L8.44776 5.23286L8.60921 4.73664L8.18896 4.43037H8.70892L8.87037 3.93652Z"
          fill="white"
        />
        <path
          d="M3.14137 5.74097L3.30282 6.23481H3.82277L3.40253 6.54109L3.56161 7.0373L3.14137 6.73102L2.71875 7.0373L2.8802 6.54109L2.45996 6.23481H2.97992L3.14137 5.74097Z"
          fill="white"
        />
        <path
          d="M6.87818 5.74097L7.03963 6.23481H7.55959L7.13935 6.54109L7.29842 7.0373L6.87818 6.73102L6.45557 7.0373L6.61702 6.54109L6.19678 6.23481H6.71674L6.87818 5.74097Z"
          fill="white"
        />
        <path
          d="M10.7034 5.74097L10.8648 6.23481H11.3848L10.9645 6.54109L11.1236 7.0373L10.7034 6.73102L10.2831 7.0373L10.4422 6.54109L10.022 6.23481H10.5419L10.7034 5.74097Z"
          fill="white"
        />
        <path
          d="M12.4319 3.93652L12.5933 4.43037H13.1133L12.6931 4.73664L12.8545 5.23286L12.4319 4.92658L12.0117 5.23286L12.1731 4.73664L11.7505 4.43037H12.2704L12.4319 3.93652Z"
          fill="white"
        />
        <path
          d="M1.30836 7.60474L1.46981 8.09858H1.98977L1.56715 8.40485L1.7286 8.90107L1.30836 8.59479L0.885745 8.90107L1.04719 8.40485L0.626953 8.09858H1.14691L1.30836 7.60474Z"
          fill="white"
        />
        <path
          d="M5.04566 7.60474L5.20474 8.09858H5.72707L5.30446 8.40485L5.4659 8.90107L5.04566 8.59479L4.62305 8.90107L4.7845 8.40485L4.36426 8.09858H4.88422L5.04566 7.60474Z"
          fill="white"
        />
        <path
          d="M8.87037 7.60474L9.03182 8.09858H9.55178L9.12916 8.40485L9.29061 8.90107L8.87037 8.59479L8.44776 8.90107L8.60921 8.40485L8.18896 8.09858H8.70892L8.87037 7.60474Z"
          fill="white"
        />
        <path
          d="M3.14137 9.40918L3.30282 9.9054H3.82277L3.40253 10.2093L3.56161 10.7055L3.14137 10.3992L2.71875 10.7055L2.8802 10.2093L2.45996 9.9054H2.97992L3.14137 9.40918Z"
          fill="white"
        />
        <path
          d="M6.87818 9.40918L7.03963 9.9054H7.55959L7.13935 10.2093L7.29842 10.7055L6.87818 10.3992L6.45557 10.7055L6.61702 10.2093L6.19678 9.9054H6.71674L6.87818 9.40918Z"
          fill="white"
        />
        <path
          d="M10.7034 9.40918L10.8648 9.9054H11.3848L10.9645 10.2093L11.1236 10.7055L10.7034 10.3992L10.2831 10.7055L10.4422 10.2093L10.022 9.9054H10.5419L10.7034 9.40918Z"
          fill="white"
        />
        <path
          d="M12.4319 7.60474L12.5933 8.09858H13.1133L12.6931 8.40485L12.8545 8.90107L12.4319 8.59479L12.0117 8.90107L12.1731 8.40485L11.7505 8.09858H12.2704L12.4319 7.60474Z"
          fill="white"
        />
        <path
          d="M1.30836 11.2041L1.46981 11.6979H1.98977L1.56715 12.0042L1.7286 12.5004L1.30836 12.1942L0.885745 12.5004L1.04719 12.0042L0.626953 11.6979H1.14691L1.30836 11.2041Z"
          fill="white"
        />
        <path
          d="M5.04566 11.2041L5.20474 11.6979H5.72707L5.30446 12.0042L5.4659 12.5004L5.04566 12.1942L4.62305 12.5004L4.7845 12.0042L4.36426 11.6979H4.88422L5.04566 11.2041Z"
          fill="white"
        />
        <path
          d="M8.87037 11.2041L9.03182 11.6979H9.55178L9.12916 12.0042L9.29061 12.5004L8.87037 12.1942L8.44776 12.5004L8.60921 12.0042L8.18896 11.6979H8.70892L8.87037 11.2041Z"
          fill="white"
        />
        <path
          d="M3.14137 13.0085L3.30282 13.5048H3.82277L3.40253 13.811L3.56161 14.3049L3.14137 13.9986L2.71875 14.3049L2.8802 13.811L2.45996 13.5048H2.97992L3.14137 13.0085Z"
          fill="white"
        />
        <path
          d="M6.87818 13.0085L7.03963 13.5048H7.55959L7.13935 13.811L7.29842 14.3049L6.87818 13.9986L6.45557 14.3049L6.61702 13.811L6.19678 13.5048H6.71674L6.87818 13.0085Z"
          fill="white"
        />
        <path
          d="M10.7034 13.0085L10.8648 13.5048H11.3848L10.9645 13.811L11.1236 14.3049L10.7034 13.9986L10.2831 14.3049L10.4422 13.811L10.022 13.5048H10.5419L10.7034 13.0085Z"
          fill="white"
        />
        <path
          d="M12.4319 11.2041L12.5933 11.6979H13.1133L12.6931 12.0042L12.8545 12.5004L12.4319 12.1942L12.0117 12.5004L12.1731 12.0042L11.7505 11.6979H12.2704L12.4319 11.2041Z"
          fill="white"
        />
        <path
          d="M1.30836 14.8604L1.46981 15.3566H1.98977L1.56715 15.6628L1.7286 16.1567L1.30836 15.8504L0.885745 16.1567L1.04719 15.6628L0.626953 15.3566H1.14691L1.30836 14.8604Z"
          fill="white"
        />
        <path
          d="M5.04566 14.8604L5.20474 15.3566H5.72707L5.30446 15.6628L5.4659 16.1567L5.04566 15.8504L4.62305 16.1567L4.7845 15.6628L4.36426 15.3566H4.88422L5.04566 14.8604Z"
          fill="white"
        />
        <path
          d="M8.87037 14.8604L9.03182 15.3566H9.55178L9.12916 15.6628L9.29061 16.1567L8.87037 15.8504L8.44776 16.1567L8.60921 15.6628L8.18896 15.3566H8.70892L8.87037 14.8604Z"
          fill="white"
        />
        <path
          d="M12.4319 14.8604L12.5933 15.3566H13.1133L12.6931 15.6628L12.8545 16.1567L12.4319 15.8504L12.0117 16.1567L12.1731 15.6628L11.7505 15.3566H12.2704L12.4319 14.8604Z"
          fill="white"
        />
        <path d="M59.7574 4.95032H14.521V7.50975H59.7574V4.95032Z" fill="#D40000" />
        <path d="M59.7574 0.045166H14.521V2.6046H59.7574V0.045166Z" fill="#D40000" />
        <path d="M59.7574 14.8604H14.521V17.4198H59.7574V14.8604Z" fill="#D40000" />
        <path d="M59.7574 9.95532H14.521V12.5148H59.7574V9.95532Z" fill="#D40000" />
        <path d="M59.7575 24.5663H-7.96289V27.1257H59.7575V24.5663Z" fill="#D40000" />
        <path d="M59.7575 19.6636H-7.96289V22.223H59.7575V19.6636Z" fill="#D40000" />
        <path d="M59.7575 29.5736H-7.96289V32.133H59.7575V29.5736Z" fill="#D40000" />
      </g>
    </svg>
  );
}
